// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"f520408c","284":"a9e5952e","333":"fb5f0e03"}[chunkId] + ".chunk.js";
};